import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { usePagination } from "../../hooks/use-pagination/use-pagination";
import { PaginationProps } from "./pagination.types";
import { ChevronItem } from "./shared/chevron-item";

export const Pagination = ({
  onPageClick,
  onNextPageClick,
  onPrevPageClick,
  loading,
  page = 1,
}: PaginationProps) => {
  const { getChevronIconColor, pages, maxVisibleButtons } = usePagination({
    count: 1000,
    page,
  });

  const renderPaginationButton = (item: number) => {
    const pageActive =
      page === item
        ? "bg-indigo-600 text-white"
        : "text-gray-900 hover:bg-gray-50";
    return (
      <button
        key={item}
        disabled={loading}
        name={`button-pagination-${item}`}
        className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300  focus:z-20 focus:outline-offset-0 ${pageActive}`}
        onClick={() => {
          if (typeof onPageClick === "function") {
            onPageClick(item);
          }
        }}
      >
        {item}
      </button>
    );
  };
  const renderPaginationButtons = () => {
    let renderedButtons = [];

    if (pages.length <= maxVisibleButtons) {
      renderedButtons = pages.map((item) => renderPaginationButton(item));
    } else {
      let start = 1;
      let end = maxVisibleButtons - 1;

      if (page >= maxVisibleButtons) {
        start = page - 3;
        end = page + 1;
      }

      if (start > 2) {
        renderedButtons.push(renderPaginationButton(1));
        if (start > 3) {
          renderedButtons.push(
            <button
              disabled={loading}
              key="ellipsis-button-start"
              name="ellipsis-button-start"
              className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 text-gray-900`}
            >
              ...
            </button>,
          );
        }
      }

      if (end > pages.length - 1) {
        start -= end - (pages.length - 1);
        end = pages.length - 1;
      }

      for (let i = start; i <= end; i++) {
        renderedButtons.push(renderPaginationButton(i));
      }

      if (end < pages.length - 1) {
        renderedButtons.push(
          <button
            disabled={loading}
            key="ellipsis-button-end"
            name="ellipsis-button-end"
            className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 text-gray-900`}
          >
            ...
          </button>,
        );
      }

      renderedButtons.push(renderPaginationButton(pages.length));
    }

    return renderedButtons;
  };

  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-1">
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            Total de bookings <span className="font-medium font-bold">554</span>
          </p>
        </div>
        <div>
          <nav
            className="isolate inline-flex -space-x-px rounded-md shadow-sm"
            aria-label="Pagination"
          >
            <ChevronItem
              onClick={onPrevPageClick}
              title="Previous"
              icon={<ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />}
              disabled={getChevronIconColor("Previous")}
            />

            {renderPaginationButtons()}
            <ChevronItem
              onClick={onNextPageClick}
              title="Next"
              icon={<ChevronRightIcon className="h-5 w-5" aria-hidden="true" />}
              disabled={getChevronIconColor("Next")}
            />
          </nav>
        </div>
      </div>
    </div>
  );
};
